import { ExitGameModalTranslations } from "./types";

export const deTranslations: ExitGameModalTranslations = {
    title: "Achtung!",
    subtitle:"Sind Sie sicher? Wenn Sie die Session jetzt beenden, können Sie Ihre virtuellen Patient:innen nicht weiterbehandeln.",
    leaveText: "Verlassen", 
    cancelText: "Abbrechen",
};